import React from 'react';

import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from '../../core-ui';
import formatCurrency from '../../core/support/formatCurrency';
import { VendorInvoice } from '../../runtypes/VendorRuntype';
import { getTotals } from '../../support/shared/billing';
import { Icon } from '../uiold';

type Props = {
  includeBillingSummary?: boolean;
  setVendorInvoiceId: (vendorInvoiceId: string | undefined) => void;
  vendorInvoiceId: string | undefined;
  vendorInvoices: Array<VendorInvoice>;
};

export function InvoiceMenu(props: Props) {
  const {
    includeBillingSummary,
    setVendorInvoiceId,
    vendorInvoiceId,
    vendorInvoices,
  } = props;

  const currentVendorInvoice = vendorInvoices.find(
    (vendorInvoice) => vendorInvoice.id === vendorInvoiceId,
  );

  return (
    <Menu>
      <MenuButton as={Button} rightIcon={<Icon name="chevronDown" size="S" />}>
        {makeInvoiceLabel(currentVendorInvoice)}
      </MenuButton>
      <Portal>
        <MenuList width="100%">
          {includeBillingSummary && (
            <InvoiceMenuItem setVendorInvoiceId={setVendorInvoiceId} />
          )}
          {vendorInvoices.map((vendorInvoice) => (
            <InvoiceMenuItem
              key={vendorInvoice.id}
              setVendorInvoiceId={setVendorInvoiceId}
              vendorInvoice={vendorInvoice}
            />
          ))}
        </MenuList>
      </Portal>
    </Menu>
  );
}

type MenuItemProps = {
  setVendorInvoiceId: (invoiceId: string | undefined) => void;
  vendorInvoice?: VendorInvoice;
};

function InvoiceMenuItem(menuItemProps: MenuItemProps) {
  const { setVendorInvoiceId, vendorInvoice } = menuItemProps;
  return (
    <MenuItem
      onClick={() => {
        setVendorInvoiceId(vendorInvoice?.id ?? undefined);
      }}
    >
      {makeInvoiceLabel(vendorInvoice)}
    </MenuItem>
  );
}

export function makeInvoiceLabel(vendorInvoice?: VendorInvoice) {
  if (!vendorInvoice) {
    return t('Billing Summary');
  }
  const { remainingBalance } = getTotals(vendorInvoice.invoicedLineItems);
  return `${vendorInvoice.created_at.split('T')[0]} - ${formatCurrency(
    remainingBalance * 100,
  )}`;
}
